import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { setIntervalIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setIntervalIfPossible";
import differenceInDays from "date-fns/differenceInDays";
import differenceInHours from "date-fns/differenceInHours";
import differenceInMinutes from "date-fns/differenceInMinutes";
import differenceInSeconds from "date-fns/differenceInSeconds";
import { useCallback, useEffect, useMemo, useState } from "react";
export var useFirstOrderIncentiveTimeRemaining = function(expiresAt) {
    var _useState = _sliced_to_array(useState(Date.now()), 2), timeNow = _useState[0], setTimeNow = _useState[1];
    useEffect(function() {
        var interval = setIntervalIfPossible(function() {
            return setTimeNow(Date.now());
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    var getRemainingTimeInterval = useCallback(function() {
        var timestamp = Math.min(timeNow, expiresAt);
        return {
            start: timestamp,
            end: expiresAt
        };
    }, [
        expiresAt,
        timeNow
    ]);
    var daysRemaining = useMemo(function() {
        var remainingTimeInterval = getRemainingTimeInterval();
        return differenceInDays(remainingTimeInterval.end, remainingTimeInterval.start);
    }, [
        getRemainingTimeInterval
    ]);
    var hoursRemaining = useMemo(function() {
        var remainingTimeInterval = getRemainingTimeInterval();
        return differenceInHours(remainingTimeInterval.end, remainingTimeInterval.start);
    }, [
        getRemainingTimeInterval
    ]);
    var timeRemaining = useMemo(function() {
        var toTwoDigits = function(str) {
            return str.padStart(2, "0");
        };
        var remainingInterval = getRemainingTimeInterval();
        var totalHours = differenceInHours(remainingInterval.end, remainingInterval.start);
        var totalMinutes = differenceInMinutes(remainingInterval.end, remainingInterval.start);
        var totalSeconds = differenceInSeconds(remainingInterval.end, remainingInterval.start);
        var remainderMinutes = totalMinutes - totalHours * 60;
        var remainderSeconds = totalSeconds - totalMinutes * 60;
        return "".concat(totalHours, ":").concat(toTwoDigits("".concat(remainderMinutes)), ":").concat(toTwoDigits("".concat(remainderSeconds)));
    }, [
        getRemainingTimeInterval
    ]);
    return {
        daysRemaining: daysRemaining,
        hoursRemaining: hoursRemaining,
        timeRemaining: timeRemaining
    };
};
